// Page views only: never send arbitrary query values or auth callback fragments.
// Login/signup are existing, non-sensitive view names, not conversion events.
export function analyticsPageView(event) {
  if (event.type !== 'pageview') return null;
  try {
    const url = new URL(event.url);
    const auth = url.pathname === '/' ? url.searchParams.get('auth') : null;
    url.search = '';
    url.hash = '';
    if (auth === 'login' || auth === 'signup') url.searchParams.set('auth', auth);
    return { ...event, url: url.href };
  } catch {
    return null;
  }
}
